<template>
  <!--
      作者：gmshop
      时间：2022-12-2
      描述：发票管理
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="抬头名称"><el-input v-model="formInline.name" placeholder="请输抬头名称"></el-input></el-form-item>
        <el-form-item label="发票类型">
          <el-select v-model="formInline.invoice_type" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option label="增值税普通发票" value="1"></el-option>
            <el-option label="增值税专用发票" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="抬头类型">
          <el-select v-model="formInline.header_type" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option label="个人" value="1"></el-option>
            <el-option label="企业" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.create_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit()">查询</el-button></el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部发票" name="0"></el-tab-pane>
          <el-tab-pane :label="'申请中(' + (arr[10] ? arr[10].total : 0) + ')'" name="10"></el-tab-pane>
          <el-tab-pane :label="'已开票(' + (arr[20] ? arr[20].total : 0) + ')'" name="20"></el-tab-pane>
          <el-tab-pane :label="'不通过(' + (arr[30] ? arr[30].total : 0) + ')'" name="30"></el-tab-pane>
        </el-tabs>
        <el-table :data="tableData" border style="width: 100%" v-loading="loading">
          <!-- <el-table-column prop="order_no" label="订单号" width="130"></el-table-column> -->
          <el-table-column prop="name" label="抬头名称">
            <template slot-scope="scope">
              <span>{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="invoice_type.text" label="发票类型">
            <template slot-scope="scope">
              <span>{{ scope.row.invoice_type.text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="header_type.text" label="抬头类型">
            <template slot-scope="scope">
              <span>{{ scope.row.header_type.text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="金额">
            <template slot-scope="scope">
              <span class="orange">{{ scope.row.amount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="时间" width="220">
            <template slot-scope="scope">
              <p class="gray6">
                <span class="gray9">申请时间：</span>
                {{ scope.row.apply_time }}
              </p>
              <p class="gray6">
                <span class="gray9">开票时间：</span>
                {{ scope.row.invoicing_time }}
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="user.nickName" label="用户">
            <template slot-scope="scope">
              <span>{{ scope.row.user.nickName }}</span>
              <br />
              <span class="gray9">(ID:{{ scope.row.user.user_id }})</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="开票状态" width="130">
            <template slot-scope="scope">
              <span class="blue" v-if="scope.row.status.value==10">{{ scope.row.status.text }}</span>
              <span class="green" v-if="scope.row.status.value==20">{{ scope.row.status.text }}</span>
              <span class="red" v-if="scope.row.status.value==30">{{ scope.row.status.text }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="110">
            <template slot-scope="scope">
              <p><el-button @click="Detail(scope.row.order_invoice_id)" type="text" size="small">发票详情</el-button></p>
              <p><el-button v-if="scope.row.status.value == 10" @click="Detail(scope.row.order_invoice_id)" type="text" size="small">去审核</el-button></p>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[2, 10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import OrderApi from '@/api/order.js';
export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        name: '',
        invoice_type: '',
        header_type: '',
        create_time: ''
      },
      status: 0,
      arr: [],

      activeName: 0
    };
  },
  created() {
    let tabs = this.$db.getRouteField(this, 'tabs');
    let page = this.$db.getRouteField(this, 'page');
    if (tabs) this.activeName = tabs;
    if (tabs) this.status = tabs;
    if (page) this.curPage = page;
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      this.$db.setRoute(this, {'page': val});
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    /*切换菜单*/
    handleClick(tab, event) {
      this.$db.setRoute(this, {'tabs': tab.name, 'page': 1});
      this.curPage = 1;
      this.status = tab.name;
      this.getTableList();
    },

    /*获取列表*/
    getTableList(params = '') {
      let self = this;
      let Params = {};
      Params.status = self.status;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      if (params != '') {
        Params.name = params.name;
        Params.invoice_type = params.invoice_type;
        Params.header_type = params.header_type;
        Params.create_time = params.create_time;
      }
      self.loading = true;
      OrderApi.getInvoiceList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          // self.exStyle = data.data.ex_style;
          // self.shopList = data.data.shopList;
          self.arr = data.data.arr;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.$db.setRoute(this, {'page': 1});
      let self = this;
      let Params = this.formInline;
      self.getTableList(Params);
    },

    /*详情*/
    Detail(e) {
      let self = this;
      let order_invoice_id = e;
      this.$router.push({
        path: '/order/invoice/Detail',
        query: {
          order_invoice_id: order_invoice_id
        }
      });
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/order/invoice/index.vue